import styled from '@emotion/styled';

export const BoxGray = styled.div`
    padding: 8px;
    width: 100%;
    background: ${(p) => p.theme.color.grayDark2};
    color: white;
`;

BoxGray.displayName = 'BoxGray';
